// material-ui
import { styled } from '@mui/material/styles';

// project imports
import { drawerWidth } from 'store/constant';

// ==============================|| MAIN LAYOUT - STYLED ||============================== //

const MainContentStyled = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'borderRadius'
})(({ theme, open, borderRadius }) => ({
  backgroundColor: theme.palette?.mode === 'dark' 
    ? (theme.palette?.background?.default || '#101216') 
    : (theme.palette?.grey?.[100] || '#F8FAFC'),
  minWidth: '1%',
  width: '100%',
  minHeight: 'calc(100vh - 72px)',
  flexGrow: 1,
  padding: '8px 20px',
  marginTop: 72,
  marginRight: 0,
  borderRadius: `${borderRadius}px`,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  ...(!open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter + 200
    }),
    [theme.breakpoints.up('md')]: {
      marginLeft: -(drawerWidth - 72),
      width: `calc(100% - 72px)`,
      marginTop: 72
    }
  }),
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter + 200
    }),
    marginLeft: 0,
    marginTop: 72,
    width: `calc(100% - ${drawerWidth}px)`,
    [theme.breakpoints.up('md')]: {
      marginTop: 72
    }
  }),
  [theme.breakpoints.down('md')]: {
    marginLeft: 0,
    padding: 8,
    marginTop: 72,
    ...(!open && {
      width: '100%'
    })
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    marginRight: 0
  }
}));

export default MainContentStyled;
